import { render } from "./TransactionDetails.vue?vue&type=template&id=37d67c06"
import script from "./TransactionDetails.vue?vue&type=script&lang=js"
export * from "./TransactionDetails.vue?vue&type=script&lang=js"
script.render = render

export default script